import { EventKey } from '../player/enums/event-key';
export class StatsForNerdsStore {
    #player = null;
    #store = {
        statsForNerdsVisible: false,
    };
    #callback = null;
    set player(player) {
        this.#player = player;
    }
    #statsForNerdsChanged = (event) => {
        this.#store = {
            ...event,
        };
        this.#callback?.();
    };
    subscribe(callback) {
        if (this.#callback) {
            this.#player?.off(EventKey.STATS_FOR_NERDS_CHANGED, this.#statsForNerdsChanged);
        }
        this.#player?.on(EventKey.STATS_FOR_NERDS_CHANGED, this.#statsForNerdsChanged);
        this.#callback = callback;
        return () => {
            this.#player?.off(EventKey.STATS_FOR_NERDS_CHANGED, this.#statsForNerdsChanged);
            this.#callback = null;
        };
    }
    getSnapshot() {
        return this.#store;
    }
}
